import React, { FC } from 'react';
import { PageData, Project } from 'types/Page';
import { Checkbox, Field, Icon, IconButton, Select } from '@kontentino/ui';
import { faX } from '@fortawesome/pro-regular-svg-icons/faX';
import { ShiftPostsTargetValidationError } from 'app/modules/posts/components/shiftPosts/ShiftTargetProfilesSelect';
import ShiftTargetProjectPageSelector from './shiftTargetProjectOfProfileSelect/ShiftTargetProjectPageSelector';
import { useTranslation } from 'react-i18next';
type Props = {
  targetNumber?: number;
  onRemoveTarget?(): void;
  error?: Omit<ShiftPostsTargetValidationError, 'id'>;
  pages: PageData[];
  projects: Project[];
  selectedProfile?: PageData;
  onProfileChange: (id: number) => void;
  selectedProject?: Project;
  onProjectChange: (id: number) => void;
  onCloneAsDraftChange?: () => void;
  cloneAsDraft?: boolean;
  dataNamePrefix: string;
  isLoading?: boolean;
};

const ShiftTargetProjectOfProfileSelect: FC<Props> = ({
  error,
  onRemoveTarget,
  targetNumber,
  pages,
  selectedProfile,
  selectedProject,
  onProjectChange,
  projects,
  onProfileChange,
  cloneAsDraft,
  onCloneAsDraftChange,
  dataNamePrefix,
  isLoading,
}) => {
  const { t } = useTranslation();
  return (
    <div className="tw-flex">
      {targetNumber && (
        <div className="tw-mr-3 tw-mt-2 tw-flex tw-flex-1 tw-cursor-pointer tw-gap-2">
          {t('postsShift.target')} {targetNumber}:
          {onRemoveTarget && (
            <IconButton
              size="small"
              variant="secondary"
              icon={<Icon icon={faX} />}
              onClick={onRemoveTarget}
            />
          )}
        </div>
      )}
      <div className="tw-flex tw-flex-[5] tw-flex-col tw-gap-4">
        <Field.Group>
          <Field.Label required>{t('postsShift.targetProfile')}</Field.Label>
          <div
            data-name={`${dataNamePrefix}_profile-input`}
            data-cy={`${dataNamePrefix}_profile-input`}
          >
            <ShiftTargetProjectPageSelector
              pages={pages}
              onProfileChange={onProfileChange}
              value={selectedProfile}
            />
          </div>
          <Field.Error>{error?.profileId}</Field.Error>
        </Field.Group>
        <Field.Group>
          <Field.Label required>{t('contentPlan')}</Field.Label>
          <div
            data-name={`${dataNamePrefix}_content-plan-input`}
            data-cy={`${dataNamePrefix}_content-plan-input`}
            className="tw-max-h-[6.25rem]"
          >
            <Select
              isLoading={isLoading}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (styles) => ({
                  ...styles,
                  zIndex: 1010,
                }),
              }}
              placeholder={t('selectContentPlan')}
              isDisabled={!selectedProfile || isLoading}
              options={projects.map((project) => ({
                value: project.id,
                label: project.name,
              }))}
              onChange={(option) => {
                if (option?.value) {
                  onProjectChange(option.value);
                }
              }}
              isSearchable
              value={
                selectedProject
                  ? { label: selectedProject.name, value: selectedProject.id }
                  : null
              }
            />
          </div>
          <Field.Error>{error?.projectId}</Field.Error>
        </Field.Group>
        {typeof onCloneAsDraftChange === 'function' && (
          <div className="tw-mt-3 tw-self-end">
            <Field.Group className="!tw-flex-row">
              <Checkbox
                onChange={onCloneAsDraftChange}
                checked={cloneAsDraft}
              />
              <Field.Label>{t('postsShift.cloneAsDraft')}</Field.Label>
            </Field.Group>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShiftTargetProjectOfProfileSelect;
